import type {
	WeddingGuest,
	WeddingParty
} from "~/types/supabase";
import type {
	ToastMessage
} from "~/types/utility";

export const utilityStores = () => {
	const activeRoute = useState<string>( "active-route", () => "/" );

	return {
		activeRoute
	};
};

// Stores the active toast message. This is used to display messages to the user, such as errors or warnings
export const useActiveToastMessage = () => useState<ToastMessage | null>( "active-toast-message", () => null );

export const useGuestAndPartyInfo = () => {
	const guestAndPartyInfo = useState<{ weddingGuests: WeddingGuest[]; party: WeddingParty | null; randomUUID: string }>( "guest-and-party-info", () => {
		return {
			weddingGuests: [],
			party: null,
			randomUUID: ""
		};
	} );

	return { guestAndPartyInfo };
};